<section class="cz-recommendations-configuration-survey-rule-control" [ngClass]="{'existing-rule': !newRule}" *ngIf="!ruleNotActive">
  <div class="row middle-xs">
    <div class="col-xs">
      <mat-form-field class="form-field form-full-width-control">
        <mat-label>{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_survey_question | translate}}</mat-label>
        <mat-select [formControl]="questionControl">
          <mat-optgroup *ngFor="let listItem of ruleData.listStructure" [label]="listItem.label">
            <mat-option *ngFor="let question of listItem.questions" [value]="question">{{question.label}}</mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs">
      <mat-form-field class="form-field form-full-width-control">
        <mat-label>{{ _defaultStrings?.defaultStringArray?.$recommendation_config_recomm_survey_answer | translate}}</mat-label>
        <mat-select [formControl]="answerControl">
          <mat-option *ngFor="let answer of selectedQuestion.answers" [value]="answer">{{answer.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="!newRule">
      <div class="col-xs-1 center-xs edit-actions" *ngIf="!editRule">
        <button mat-icon-button type="button" color="accent" (click)="editingRule()"><mat-icon>edit</mat-icon></button>
      </div> 
      <div class="col-xs-3 edit-actions" *ngIf="editRule">
        <button mat-icon-button color="accent" (click)="saveRule()">
            <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button color="error" (click)="deleteRule()">
            <mat-icon>delete</mat-icon>
        </button>
        <button mat-icon-button (click)="closeEditingRule()">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="newRule">
      <div class="col-xs-1">
        <button mat-icon-button
                color="accent"
                (click)="saveRule()">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
